import React, { useContext, useMemo } from 'react';
import { useParams } from 'umi';
import CommonPageRender from '@home/components/CommonPageRender';
import type { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import { StudioContext } from '@/pages/home/pages/studio/context';
import { buildTabChildPath } from '@/pages/home/pages/studio/utils';
import { safeDecodePageConfigPath } from '../authPath/configUtils';
import TabContainerContent from './TabContainerContent';
import './index.scss';

interface ITabContainerProps {
  children?: React.ReactNode;
}

interface ITabContainerRouteParams {
  studioId?: string;
  gameCode?: string;
}

const TAB_CONTAINER_PAGE_CONFIG = {
  name: 'TabContainer',
} as unknown as IPageConfigType;

/**
 * display_mode=tab 的配置化入口。
 * 固定使用首个 Tab 的业务路径获取整份配置，切换子 Tab 时不重复请求。
 */
const TabContainer: React.FC<ITabContainerProps> = ({ children }) => {
  const { studioId = '', gameCode = '' } = useParams<ITabContainerRouteParams>() || {};
  const { tabContainerMenu } = useContext(StudioContext);
  const firstTab = tabContainerMenu?.tabs?.[0];
  const reqParams = useMemo(() => {
    if (!firstTab) return '';
    return safeDecodePageConfigPath(
      buildTabChildPath(tabContainerMenu?.name_en ?? '', firstTab),
    );
  }, [firstTab, tabContainerMenu?.name_en]);

  if (!reqParams) {
    return <TabContainerContent>{children}</TabContainerContent>;
  }

  return (
    <CommonPageRender
      key={`${studioId}-${gameCode}-${reqParams}`}
      reqParams={reqParams}
      frameType="game"
      routeChildren={children}
      pageConfigInit={TAB_CONTAINER_PAGE_CONFIG}
    />
  );
};

export default TabContainer;
